import { render, staticRenderFns } from "./bszn.vue?vue&type=template&id=9a77a91a&scoped=true"
import script from "./bszn.vue?vue&type=script&lang=js"
export * from "./bszn.vue?vue&type=script&lang=js"
import style0 from "./bszn.vue?vue&type=style&index=0&id=9a77a91a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a77a91a",
  null
  
)

export default component.exports